<template>
  <keep-alive exclude="ChecklistDetailComponent">
      <component :is="currentACLComponent" :selectedChecklistId="currentSelectedChecklistId" :selectedChecklistName="currentSelectedChecklistName" @checklistSelected="selectChecklistId" @detailClosed="resetChecklistId"></component>
  </keep-alive>
</template>

<script>
import ChecklistOverviewComponent from "@/components/modules/checklist/ChecklistOverviewComponent";
import ChecklistDetailComponent from "@/components/modules/checklist/ChecklistDetailComponent";

const overviewComponent = 'overviewComp'
const checklistDetailComponent = 'detailComp'

export default {
name: "allChecklistsComponent",
  data: () => {
    return {
      currentACLComponent: null,
      currentSelectedChecklistId: null,
      currentSelectedChecklistName: null,
    }
  },
  components: {
    overviewComp: ChecklistOverviewComponent,
    detailComp: ChecklistDetailComponent
  },
  methods:{
    selectChecklistId($cldata){
      //window.console.log('SELECTED !!!');
      //window.console.log($cldata.id);
      this.currentSelectedChecklistId = $cldata.id;
      this.currentSelectedChecklistName = $cldata.name;
      this.currentACLComponent = checklistDetailComponent;
    },
    resetChecklistId(){
      this.currentSelectedChecklist = null;
      this.currentSelectedChecklistName = null;
      this.currentACLComponent = overviewComponent
    }
  },
  async mounted() {
    this.currentACLComponent = overviewComponent
  }
}
</script>

<style scoped>

</style>